import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomTable from "rc-material-table";
import PageHeader from "../../component/header";
import { apiBlogs, apiWidgets, method } from "../../apiPath";
import { getToast } from "../../common/utils";
import { useApi } from "../../hooks";
import keyNames from "../../keyName";
import { columns } from "./columns";
import { Box, Typography } from "@mui/material";

const { get } = method;
const Blogs = () => {
  const hitApi = useApi();
  const navigate = useNavigate();
  const storeData = useSelector((state) => state.mainReducer);
  const { blogData } = storeData;
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const callBack = (cbd) => {
    navigate("/app/blog/add", { state: cbd });
  };
  const btn = {
    show: true,
    text: "Add Blog",
    type: "contained",
    callBack: () => callBack("add"),
  };

  useEffect(() => {
    // const toast = getToast("error");
    if (blogData === null) {
      hitApi(apiBlogs, null, get, keyNames.blogData);
      setLoading(false);
    } else if (blogData?.length >= 0) {
      setEntries(
        blogData.map((item, index) => {
          item.sortOrder = index + 1;
          return item;
        })
      );
      setLoading(false);
    }
  }, [blogData, hitApi]);
  const handleView = (item, path) => {
    navigate(path, { state: item });
  };
  const handleDelete = (id) => {
    const toast = getToast("success");
    hitApi(`${apiBlogs}/${id}`, null, method.delete, keyNames.blogData, toast, {
      type: "delete",
    });
  };

  // pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const pagination = {
    rowsPerPageOptions: [8, 10, 20],
    rowsPerPage: rowsPerPage,
    page: page,
    count: entries.length,
    component: "div",
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage,
  };
  const paginatedData = useMemo(() => {
    const startIndex = page * rowsPerPage;
    return entries.slice(startIndex, startIndex + rowsPerPage);
  }, [entries, page, rowsPerPage]);

  return (
    <>
      <PageHeader btn={btn} title="All Blogs" />

      {loading ? (
        <Typography variant="body1" sx={{ mt: 3 }}>
          Loading blogs...
        </Typography>
      ) : entries.length === 0 ? (
        <Box
          sx={{
            mt: 5,
            textAlign: "center",
            p: 4,
            border: "1px dashed grey",
            borderRadius: 2,
            backgroundColor: "#fafafa",
          }}
        >
          <Typography variant="h6" color="text.secondary">
            No blogs found for this user.
          </Typography>
        </Box>
      ) : (
        <CustomTable
          columns={columns(handleView, handleDelete)}
          data={paginatedData ?? []}
          pagination={pagination}
          tableProps={{
            stickyHeader: true,
          }}
          sx={{
            mt: 3,
            "&>.MuiPaper-elevation": {
              boxShadow: "none",
              overflowX: "auto",
              maxHeight: "calc(100vh - 260px)",
            },
          }}
        />
      )}
    </>
  );
};

export default Blogs;
